import { useEffect, useState } from "react";
import { wpGet } from "../utils/api";

type WPRoot = {
  name?: string;
  description?: string;
  url?: string;
  home?: string;
  site_icon_url?: string;
};

export default function useWPSiteMeta() {
  const [meta, setMeta] = useState<WPRoot | null>(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const data = await wpGet<WPRoot>("/");
        if (active) setMeta(data);
      } catch {
        if (active) setMeta(null);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, []);

  return meta;
}
